import css from "./PopularPages.module.css";

import { ReactNode } from "react";
import { PopularPage } from "~/util/top";
import { QuestLink } from "../quest/QuestLink";
import { NpcLink } from "../npc/NpcLink";
import { ItemLink } from "../item/ItemLink";
import { useT } from "~/util/Lang";
import { AuthUser } from "~/auth.server";

type GroupedPopularPages = {
  quests: PopularPage[];
  items: PopularPage[];
  npcs: PopularPage[];
};

export function PopularPages(props: {
  pages: PopularPage[];
  authUser?: AuthUser;
}) {
  const { pages, authUser } = props;
  const t = useT();

  const grouped: GroupedPopularPages = {
    quests: [],
    items: [],
    npcs: [],
  };

  for (const page of pages) {
    if (page._ === "quest") grouped.quests.push(page);
    else if (page._ === "item") grouped.items.push(page);
    else if (page._ === "npc") grouped.npcs.push(page);
  }

  for (const key of Object.keys(grouped) as (keyof GroupedPopularPages)[]) {
    grouped[key].sort((a, b) => b.views - a.views);
  }

  return (
    <div>
      <h2 className={css.title}>Popular Pages</h2>
      <div className={css.groups}>
        <div>
          <div className={css.type}>{t({ en: "Items", ru: "Предметы" })}:</div>
          {grouped.items.map((page, i) => (
            <PopularItem key={i} page={page} authUser={authUser} />
          ))}
        </div>
        <div>
          <div className={css.type}>{t({ en: "NPCs", ru: "Мобы" })}:</div>
          {grouped.npcs.map((page, i) => (
            <PopularItem key={i} page={page} authUser={authUser} />
          ))}
        </div>
        <div>
          <div className={css.type}>{t({ en: "Quests", ru: "Квесты" })}:</div>
          {grouped.quests.map((page, i) => (
            <PopularItem key={i} page={page} authUser={authUser} />
          ))}
        </div>
      </div>
    </div>
  );
}

export function PopularItem(props: { page: PopularPage; authUser?: AuthUser }) {
  const { page, authUser } = props;
  let link: ReactNode = null;

  switch (page._) {
    case "quest":
      link = <QuestLink quest={page.linkData} />;
      break;
    case "npc":
      link = <NpcLink npc={page.linkData} showIcon={true} showLvl={false} />;
      break;
    case "item":
      link = <ItemLink item={page.linkData} />;
      break;
  }
  return (
    <div className={css.item}>
      <span className={css.link}>{link}</span>
      {authUser?.isAdmin && <span className={css.views}>{page.views}</span>}
    </div>
  );
}
